import { useTranslation } from "react-i18next";

const EConsent = (props) => {
  const dateFormatOptions = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
  const currentDate = new Date().toLocaleDateString('en-US', dateFormatOptions);
  const { t } = useTranslation();

  return (
    <div>
      <h4>{t("ec_eConsentAgreement")}</h4>
      <h5>{props?.coBorrowerFullName}</h5>
      <h5>{t("ec_yourAgreement")}</h5>
      <p>
        <b>{t("ec_effectiveDate")}</b> : {t("ec_effectiveDateText")} {currentDate}.
      </p>
      <p>
        <b>{t("ec_general")}</b>
        <br />
        {t("ec_generalText")}
      </p>
      <p>
        <b>{t("ec_terminationTitle")}</b>
        <br />
        {t("ec_terminationText")}
      </p>
      <p>
        <b>{t("ec_requestingPaperTitle")}</b><br />{t("ec_requestingPaperText")}
        <br />
        &nbsp;
        <br />{t("ec_requestingPaperInfo")}:
        <br />
        <br />{t("Phone")}: 201-490-4232
        <br />
        <br />
        {t("ec_mailingAddress")}
        <br />
        {t("ec_mailingAddressText")}
      </p>
      <p>
        <b>{t("ec_retainingCopies")}</b>
        <br />
        {t("ec_retainingCopiesText")}
      </p>
      <p>
        <b>{t("ec_withDrawnConsentTitle")}</b>
        <br />
        {t("ec_withDrawnConsentText")}
        <br />
        {t("ec_withDrawnConsentText2")}
        <br /> <br />{t("ec_withDrawnConsentText3")}:<br /> <br />
        {t("Phone")}: 201-490-4232 <br /> <br />
        {t("ec_mailingAddress")}{" "}
        <br /> <br />
        {t("ec_withDrawnConsentText4")}
      </p>
      <p>
        <b>{t("ec_updatingContactTitle")}</b>
        <br />
        <br />
        {t("ec_updatingContactText")}
        <br />
        <br />{t("ec_updatingContactText2")}:
        <br />
        <br />
        {t("Phone")}: 201-490-4232
        <br />
        <br />
        {t("ec_mailingAddress")}
        <br />
        <br />
        {t("ec_updatingContactText3")}
      </p>
      <p>
        <b>{t("ec_requiredHardwareTitle")}</b>
        <br />
        {t("ec_requiredHardwareText")}:
        <br />
        <br />
        <ul>
          <li>
            {t("ec_internetBrowser")};
          </li>
          <li>{t("ec_internetBrowserText")};</li>
          <li>
            {t("ec_currentVersion")};
          </li>
          <li>{t("ec_currentVersionText")};</li>
          <li>
            {t("ec_device")}; {t("and")}
          </li>
          <li>
            {t("ec_operatingSystem")}
          </li>
        </ul>
        <br />
        <br />
        {t("ec_operatingSystemText")}
      </p>
      <p>
        <b>{t("ec_agreement")}</b>
        <br />
        <br />
        {t("ec_agreementText")}:
        <br />
        <br />
        <ul>
          <li>
            {t("ec_accessRead")}
          </li>
          <li>{t("ec_accessReadText")}</li>
          <li>{t("ec_accessReadText2")}</li>
          <li>
            {t("ec_activeEmail")}
          </li>
          <li>{t("ec_activeEmailText")}</li>
          <li>
            {t("ec_accessDocuments")}
          </li>
        </ul>
      </p>
      <br />
      <br />
      <p>
        {t("ec_agreementText2")}
      </p>
    </div>
  );
};

export default EConsent;
